import React from 'react';
import { ReactChat } from '@shared/components/proctoring/ReactChat';
import {
  getStore,
  usePlayerStore,
  useExamSessionStore,
  useAppStore,
} from '../../../stores/StoreContext';
import { formatTime } from '../../../helpers/utilities';
import { useEffect, useRef, useState } from 'react';
import Loader from '@ui/context/session/components/Common/Loader';

const Chat = () => {
  const AppStore = getStore('appStore');

  const isLive = usePlayerStore((state) => state.isLive);
  const currentTime = usePlayerStore((state) => state.currentTime);
  const recordingStartDate = useExamSessionStore(
    (state) => state.sessionData.recordingStartDate
  );
  const canHaveLiveVideo = usePlayerStore((state) => state.canHaveLiveVideo);
  const sessionDetailsTab = useAppStore((state) => state.sessionDetailsTab);
  const isRoomConnected = useAppStore((state) => state.isRoomConnected);

  const chatRef = useRef(null);

  const [, setHighlightedMessageTime] = useState(null);

  // Scroll to bottom when chat tab is selected
  useEffect(() => {
    if (sessionDetailsTab === 'communication' && chatRef.current) {
      setTimeout(() => {
        chatRef.current.scrollToBottom(true);
      }, 100);
    }
  }, [sessionDetailsTab]);

  useEffect(() => {
    if (!isLive) {
      const hasMatch =
        chatRef.current.scrollToMessageBySessionTime(currentTime);
      if (hasMatch) {
        setHighlightedMessageTime(currentTime);
      }
    }
  }, [currentTime, isLive]);

  if (!isRoomConnected && canHaveLiveVideo) {
    return (
      <Loader
        spinnerSize="medium"
        color="primary"
        textSize="large"
        text="Connecting to the session..."
      />
    );
  }



  return (
    <ReactChat
      ref={(el) => (chatRef.current = el)}
      roomId={AppStore.roomId}
      identity={AppStore.identity}
      token={AppStore.spToken}
      referenceId={AppStore.roomId}
      apiUrl={AppStore.apiUrl}
      mediaAgent={AppStore.mediaClient}
      displayName={AppStore.user.firstName}
      startTime={recordingStartDate}
      allowNewMessage={canHaveLiveVideo}
      renderSessionTime={(seconds, message) => {
        return formatTime(seconds);
      }}
    />
  );
};

export default Chat;
